export const GET_TECHNICIANS = 'GET_TECHNICIANS';
export const GET_TECHNICIANS_LOGS = 'GET_TECHNICIAN_LOGS';
export const SET_TECHNICIANS = 'SET_TECHNICIANS';
export const SET_TECHNICIANS_LOGS = 'SET_TECHNICIANS_LOGS';
export const UPDATE_TECHNICIANS_LOG = 'UPDATE_TECHNICIANS_LOG';
export const DELETE_TECHNICIANS_LOGS = 'DELETE_TECHNICIANS_LOGS';
